import { Button, Modal } from "react-bootstrap";
import moment from "moment";

import { useTranslation } from "react-i18next";

export const ServiceDetailsModal = (props) => {
  const { showServiceModal, handleCloseServiceModal, selectedService } = props;
  const { t } = useTranslation();
  return (
    <Modal show={showServiceModal} onHide={handleCloseServiceModal}>
      <Modal.Header closeButton>
        <Modal.Title>{selectedService?.serviceName}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {selectedService && (
          <>
            {selectedService.photo && (
              <img
                src={selectedService.photo}
                alt={selectedService.serviceName}
                style={{
                  width: "100%",
                  height: "200px",
                  objectFit: "cover",
                  borderRadius: "5px",
                  marginBottom: "15px",
                }}
              />
            )}
            <p>
              <strong>{t("room.service_type")}:</strong>{" "}
              {selectedService.kindOfService}
            </p>
            <p>
              <strong>{t("room.charge_type")}:</strong>{" "}
              {selectedService.chargeType}
            </p>
            <p>
              <strong>{t("room.price")}:</strong> {selectedService.servicePrice}{" "}
              VND
            </p>
            <p>
              <strong>{t("room.addon_service.description")}:</strong>{" "}
              {selectedService.serviceDescription}
            </p>
            <p>
              <strong>{t("room.date_applied")}:</strong>{" "}
              {moment(selectedService.dateApplied.startDate).format(
                "DD-MM-YYYY"
              )}{" "}
              -{" "}
              {moment(selectedService.dateApplied.endDate).format("DD-MM-YYYY")}
            </p>
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleCloseServiceModal}>
          {t("room.close")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
